import React, { useState, useEffect } from 'react';
import { achievementService } from '../services';
import BadgeCard from '../components/BadgeCard';
import toast from 'react-hot-toast';

const Achievements = () => {
  const [progress, setProgress] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadProgress();
  }, []);

  const loadProgress = async () => {
    try {
      const response = await achievementService.getProgress();
      setProgress(response.data.data);
    } catch (error) {
      console.error('Error loading achievements:', error);
      toast.error('Error al cargar logros');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold mb-2">Logros y Medallas 🎖️</h1>
        <p className="text-gray-400">
          Desbloquea medallas completando desafíos
        </p>
      </div>

      {/* Progress Bar */}
      <div className="bg-gray-800 rounded-lg p-6 mb-6">
        <div className="flex justify-between items-center mb-3">
          <div>
            <h3 className="text-xl font-bold">Progreso Total</h3>
            <p className="text-gray-400 text-sm">
              {progress?.total_earned || 0} de {progress?.total_badges || 0} medallas desbloqueadas
            </p>
          </div>
          <div className="text-3xl font-bold text-blue-500">
            {progress?.completion_percentage || 0}%
          </div>
        </div>
        <div className="w-full bg-gray-700 rounded-full h-4">
          <div 
            className="bg-gradient-to-r from-blue-500 to-purple-500 h-4 rounded-full transition-all duration-500"
            style={{ width: `${progress?.completion_percentage || 0}%` }}
          ></div>
        </div>
      </div>

      {/* Earned Badges */}
      {progress?.earned && progress.earned.length > 0 && (
        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-4">Desbloqueadas ✨</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {progress.earned.map((badge) => (
              <BadgeCard 
                key={badge.id} 
                badge={badge}
                achievement={badge.pivot}
                locked={false}
              />
            ))}
          </div>
        </div>
      )}

      {/* Available Badges */}
      {progress?.available && progress.available.length > 0 && (
        <div>
          <h2 className="text-2xl font-bold mb-4">Por Desbloquear 🔒</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {progress.available.map((badge) => (
              <BadgeCard 
                key={badge.id} 
                badge={badge}
                locked={true}
              />
            ))}
          </div>
        </div>
      )}

      {/* Empty State */}
      {(!progress?.earned || progress.earned.length === 0) && 
       (!progress?.available || progress.available.length === 0) && (
        <div className="text-center py-12 bg-gray-800 rounded-lg">
          <div className="text-6xl mb-4">🎖️</div>
          <h3 className="text-xl font-semibold mb-2">Sin Logros Disponibles</h3>
          <p className="text-gray-400">
            Los logros estarán disponibles pronto
          </p>
        </div>
      )}
    </div>
  );
};

export default Achievements;
